import "@/App.css";
import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import { RouteFallback } from "@/components/RouteFallback";
// Route-level code splitting: heavy/less-frequent pages load on demand so the
// initial bundle stays small and reloads are fast. The <Suspense> inside Layout
// keeps the nav/footer visible while a page chunk loads.
const Explore = lazy(() => import("@/pages/Explore"));
const Search = lazy(() => import("@/pages/Search"));
const TopicDetail = lazy(() => import("@/pages/TopicDetail"));
const Universe = lazy(() => import("@/pages/Universe"));
const Dashboard = lazy(() => import("@/pages/Dashboard"));
const Timelines = lazy(() => import("@/pages/Timelines"));
const MapsPage = lazy(() => import("@/pages/MapsPage"));
const Metrics = lazy(() => import("@/pages/Metrics"));
const NarrationPilot = lazy(() => import("@/pages/NarrationPilot"));
const Messages = lazy(() => import("@/pages/Messages"));
const Store = lazy(() => import("@/pages/Store"));
const Subscribe = lazy(() => import("@/pages/Subscribe"));
const PaymentSuccess = lazy(() => import("@/pages/PaymentSuccess"));
const Archivist = lazy(() => import("@/pages/Archivist"));
const Terms = lazy(() => import("@/pages/Terms"));
const Privacy = lazy(() => import("@/pages/Privacy"));
import CodexTurntable from "@/components/audio/CodexTurntable";
import Starfield from "@/components/effects/Starfield";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SplashScreen } from "@/components/SplashScreen";

function RootRoutes() {
  const location = useLocation();
  // Handle the Google OAuth return (session_id in URL fragment) BEFORE normal routing.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/explore" element={<Explore />} />
        <Route path="/search" element={<Search />} />
        <Route path="/archivist" element={<Archivist />} />
        <Route path="/topic/:slug" element={<TopicDetail />} />
        <Route path="/timelines" element={<Timelines />} />
        <Route path="/maps" element={<MapsPage />} />
        <Route path="/metrics" element={<Metrics />} />
        <Route path="/admin/narration-pilot" element={<NarrationPilot />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/messages/:cid" element={<Messages />} />
        <Route path="/store" element={<Store />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
      </Route>
      <Route path="/universe" element={<Universe />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Login />} />
    </Routes>
  );
}

// The CODEX Field Gear store is public — no gating.

function App() {
  return (
    <ErrorBoundary>
      <SplashScreen />
      <AuthProvider>
        <BrowserRouter>
          <Starfield />
          <Suspense fallback={<RouteFallback />}>
            <RootRoutes />
          </Suspense>
          <CodexTurntable />
          <Toaster position="top-center" theme="dark" />
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
